import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingCropImageConfig } from '@/data/landingConfig/landingCropImageConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_CropImage } from './schemaObject';

interface Props {}
const CropImage: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_CropImage} />
			<LandingTemplate
				data={landingCropImageConfig}
				funnelLinkService={GenerateLandingLinkService.funnelCropImage()}
			/>
		</>
	);
};

export default CropImage;
